import { render, staticRenderFns } from "./homeworkList.vue?vue&type=template&id=5de9f17d&scoped=true&"
import script from "./homeworkList.vue?vue&type=script&lang=js&"
export * from "./homeworkList.vue?vue&type=script&lang=js&"
import style0 from "./homeworkList.vue?vue&type=style&index=0&id=5de9f17d&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5de9f17d",
  null
  
)

export default component.exports